import { FC } from 'react';
import { useSelector } from 'react-redux';
import { DropdownFilter, DropdownSuburbanArea, useDropdown } from 'shared/components/DropdownFilter';
import { selectHouseAreaAvailable, selectSuburbanAreaFilter } from 'shared/selectors/filters';
import { useSuburbanAreaChangeHandler } from './hooks';
import { FILTER_KEY } from './constants';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const SuburbanAreaContainer: FC = () => {
  const {
    label,
    value: { houseAreaMax, houseAreaMin, landAreaMax, landAreaMin },
  } = useSelector(selectSuburbanAreaFilter);

  const isHouseAreaAvailable = useSelector(selectHouseAreaAvailable);

  const { onHouseAreaMaxChange, onHouseAreaMinChange, onLandAreaMaxChange, onLandAreaMinChange } =
    useSuburbanAreaChangeHandler();

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const dropdownState = useDropdown(FILTER_KEY);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      {...dropdownState}
      showTooltip={showTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <DropdownSuburbanArea
          houseAreaMax={houseAreaMax}
          houseAreaMin={houseAreaMin}
          landAreaMax={landAreaMax}
          landAreaMin={landAreaMin}
          isHouseAreaAvailable={isHouseAreaAvailable}
          onHouseAreaMaxChange={onHouseAreaMaxChange}
          onHouseAreaMinChange={onHouseAreaMinChange}
          onLandAreaMaxChange={onLandAreaMaxChange}
          onLandAreaMinChange={onLandAreaMinChange}
        />
      }
    />
  );
};
